import React, { useState, useEffect, Fragment, useContext } from "react";
import "./Screens.scss";
import { AppContext } from "../../Context/AppContext";
import axios from "axios";
// Material UI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import Select from "@mui/material/Select";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";

// Custom Plugins
import { customCloneDeep } from "../../Plugins/HelperFunctions";

const Screen13 = () => {
  const {
    screensData,
    setScreensData,
    setActiveScreen,
    setShowSnackbar,
    setSnackbarMessage,
    setShowSpinner,
    offeredPrice,
  } = useContext(AppContext);
  const [screen13, setScreen13] = useState(screensData.screen13);
  const [unsub, setUnsub] = useState(true);
  const [timeOptions, setTimeOptions] = useState([
    "8:00 am to 12:30 pm",
    "12:30 pm to 5:00 pm",
  ]);
  const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com"
  // const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com");

  const handleChange = (e, name) => {
    let errorName = `${name}Error`;

    if (name === "date") {
      if (e === "" || e === undefined) {
        setScreen13({
          ...screen13,
          [name]: e,
          [errorName]: true,
        });
      } else {
        setScreen13({
          ...screen13,
          [name]: new Date(e).toDateString(),
          [errorName]: false,
        });
      }
    } else {
      let { name, value } = e.target;
      let errorName = `${name}Error`;

      if (value === "" || value === undefined) {
        setScreen13({
          ...screen13,
          [name]: value,
          [errorName]: true,
        });
      } else {
        setScreen13({
          ...screen13,
          [name]: value,
          [errorName]: false,
        });
      }
    }
  };

  function disableSundaysAndChristmas(date) {
    const today = new Date();
    return (
      date.getDay() === 0 ||
      (date.getDate() === 25 && date.getMonth() === 11) ||
      (today.getDate() === date.getDate() &&
        today.getMonth() === date.getMonth() &&
        today.getFullYear() === date.getFullYear() &&
        today.getHours() >= 13)
    );
  }

  // Form Validator
  const formValidator = () => {
    let inputs = ["date", "time"];
    let errors = { dateError: false, timeError: false };

    inputs.forEach((input) => {
      const errorName = `${input}Error`;
      if (screen13[input] === "" || screen13[input] === undefined) {
        errors[errorName] = true;
      }
    });

    setScreen13({
      ...screen13,
      ...errors,
    });

    if (Object.values(errors).includes(true)) {
      return false;
    }
    return true;
  };

  const saveOffer = async () => {
    let doc = {};

    const { screen11, screen12 } = screensData;

    const _screensData = {
      screen11,
      screen12,
      screen13
    };

    console.log("_SCREENDATA", _screensData);

    for (let x in _screensData) {
        doc = {...doc, ..._screensData[x]};
    }

    doc.zip = doc.zipCode;
    const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com";
  axios.put(baseUrl + "/offer/" + screensData.offerId, doc)
  .then(d => {
    
  });

  //if (window.confirm()) {
  //  setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  //}
}

  const handleNext = () => {
    if (formValidator()) {

      let clonedScreensData = customCloneDeep(screensData);
      clonedScreensData.screen13 = screen13;
      clonedScreensData.screen10.offeredPrice = offeredPrice;
      setScreensData(clonedScreensData);

      try {
        setShowSpinner(false);
        saveOffer();
        axios.post(`${baseUrl}/email`, clonedScreensData).then(() => {
          setShowSpinner(false);
          setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);
        });
      } catch (error) {
        setShowSpinner(false);
        setShowSnackbar(true);
        setSnackbarMessage("Something went wrong. Please try again.");
      }
    } else {
      setShowSnackbar(true);
      setSnackbarMessage("All required fields are not filled");
    }
  };

  const handlePrevious = () => {
    setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
  };

  useEffect(() => {
    const today = new Date();
    const selectedDate = new Date(screen13.date);

    if (selectedDate) {
      if (
        today.getDate() === selectedDate.getDate() &&
        today.getMonth() === selectedDate.getMonth() &&
        today.getFullYear() === selectedDate.getFullYear()
      ) {
        setTimeOptions(["12:30 pm to 5:00 pm"]);
      } else {
        setTimeOptions(["8:00 am to 12:30 pm", "12:30 pm to 5:00 pm"]);
      }
    }
  }, [screen13]);

  return (
    <Fragment>
      <div className="screen">
        <form>
          <Box className="screen__wrapper">
            <Typography variant="subtitle1" component="p">
              Please select a pickup time and date.
            </Typography>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                label="Date"
                disablePast
                shouldDisableDate={disableSundaysAndChristmas}
                value={screen13.date}
                error={screen13.dateError}
                onChange={(e) => handleChange(e, "date")}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <FormControl fullWidth error={screen13.timeError}>
              <InputLabel id="time-select-label">Time</InputLabel>
              <Select
                labelId="time-select-label"
                label="Time"
                name="time"
                value={screen13.time}
                onChange={(e) => handleChange(e)}
              >
                {timeOptions &&
                  timeOptions.map((option, index) => (
                    <MenuItem value={option} key={index}>
                      {option}
                    </MenuItem>
                  ))}
              </Select>
              {screen13.timeError && <FormHelperText>Required</FormHelperText>}
            </FormControl>
          </Box>
        </form>
      </div>

      <Box className="screenBtnContainer" sx={{ pt: 3 }}>
        <Button variant="outlined" color="primary" onClick={handlePrevious}>
          Previous
        </Button>

        <Button variant="contained" color="primary" onClick={handleNext}>
          Finish
        </Button>
      </Box>
    </Fragment>
  );
};

export default Screen13;
